import React from 'react';
import PrepaidConsultList from '../../../components/consult/list/prepaid-list';

export default () => {
  return <PrepaidConsultList/>
}